


export type BillAssignmentRuleTargetType = 'Private' | 'Group' | 'CostCentre';

export const BillAssignmentRuleTargetType = {
    Private: 'Private' as BillAssignmentRuleTargetType,
    Group: 'Group' as BillAssignmentRuleTargetType,
    CostCentre: 'CostCentre' as BillAssignmentRuleTargetType
};

